/* eslint-disable no-useless-escape */
import React, { useMemo } from "react";
import styled from "styled-components";
import tinyColor2 from "tinycolor2";
import { POSITION_ENUM } from "../../templates/common";
import { sendEvent } from "../../../../../../common/ApxEventHandler";
import {
  ACTION_CLASSES,
  INAPP_LAYOUT_TYPES,
  MODULE_TYPES,
  SET_BACKGROUND_COLOR,
  SET_BG_IMAGE,
  SET_BG_IMAGE_SIZE,
  SET_BORDER_BOTTOM_RADIUS,
  SET_BORDER_RADIUS,
  SET_BUTTON_BG_COLOR,
  SET_BUTTON_COLOR,
  SET_BUTTON_FONT_FAMILY,
  SET_BUTTON_FONT_SIZE,
  SET_BUTTON_FONT_STYLE,
  SET_BUTTON_IMAGE,
  SET_BUTTON_TEXT,
  SET_COLOR,
  SET_FONT_FAMILY,
  SET_FONT_SIZE,
  SET_FONT_STYLE,
  SET_IMAGE,
  SET_MODULE_TYPE,
  SET_TEXT,
  SET_VIDEO_BUTTON_COLOR,
} from "../../constants";
import { IconButton } from "@material-ui/core";

export const DEFAULT_IMAGE_DATA =
  "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";

const getFontStyle = (option) => {
  switch (option) {
    case "bold":
      return {
        fontWeight: 600,
      };
    case "bold_italic":
      return {
        fontWeight: 600,
        fontStyle: "italic",
      };
    case "italic":
      return {
        fontStyle: "italic",
      };
    default:
      return {};
  }
};

export const BUTTONS_POSITION = {
  RIGHT: "right",
  LEFT: "left",
  // MIDDLE: "middle",
  // CENTER: "center",
};

const getButtonPosition = (buttonPosition) => {
  switch (buttonPosition) {
    case BUTTONS_POSITION.RIGHT:
      return "flex-end";
    case BUTTONS_POSITION.LEFT:
      return "flex-start";
    default:
      return "flex-end";
  }
};

export const translateToFontConfig = (text_config) => {
  const { color, font_family, size, style } = text_config;
  return {
    color,
    fontFamily: font_family,
    fontSize: `${size}px`,
    fontStyle: style !== "bold" ? style : "normal",
    fontWeight: style === "bold" ? style : "normal",
    margin: 0,
    padding: 0,
    lineHeight: `${Number(size) + 2}px`,
    textAlign: "initial",
  };
};

export const StyledHolder = styled.div`
  user-select: none;
  padding: 0px;
  transition: all 0.1s ease-in-out;
  ${(props) =>
    props.selected
      ? "border: 1px dashed #2979ff;"
      : "border: 1px solid transparent;"}
  &:hover {
    box-shadow: ${(props) =>
      props.defaultBgColor ? "none" : "0 3px 3px rgba(18, 66, 74, 0.25)"};
    cursor: pointer;
    background: ${(props) =>
      props.bgColor
        ? tinyColor2(props.bgColor).complement().toHexString()
        : props.defaultBgColor || "#ffffff"};
    border: ${(props) => (props.isPure ? "none" : "1px solid #2979ff")};
  }
  width: ${(props) => (props.isPure ? "100%" : "unset")};
`;

const userSessionRegex = /(\[(user|session)_[\w\s]+\([\w\s]+\)\])+/gm;
const dynamicTextRegex = /(\[([a-zA-Z;]+)(v[\d]+);([\d\w\p\s;\[\]-]+)\])+/gm;

function renderMacros(text) {
  let renderedText = text;
  let m;
  while ((m = userSessionRegex.exec(text)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === userSessionRegex.lastIndex) {
      userSessionRegex.lastIndex++;
    }

    for (var groupIndex = 0; groupIndex < m.length; groupIndex++) {
      const match = m[groupIndex];
      if (groupIndex === 0) {
        const macro = match;
        const defaultValue = match.substring(
          match.indexOf("(") + 1,
          match.indexOf(")")
        );
        renderedText = renderedText.replace(macro, defaultValue);
      }
    }
  }

  // Replace DynamicText macors
  const temp = renderedText;
  while ((m = dynamicTextRegex.exec(temp)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === dynamicTextRegex.lastIndex) {
      dynamicTextRegex.lastIndex++;
    }

    let defaultValue = m[4];
    renderedText = renderedText.replace(m[0], defaultValue);
  }
  return renderedText;
}

function TextHolder({
  id,
  isPure = false,
  bgColor,
  config,
  handleModuleSelection,
  selected = false,
  style = {},
}) {
  const { text = "Text", ...others } = config;
  const newLineTransformation = useMemo(() => {
    return renderMacros(text)
      .split("\n")
      .map((block, index) => <div key={"text_" + index}>{block}</div>);
  }, [text]);
  return isPure ? (
    <div style={{ ...translateToFontConfig(others), ...style }}>
      {newLineTransformation}
    </div>
  ) : (
    <StyledHolder
      id={id}
      bgColor={bgColor}
      selected={selected}
      onClick={handleModuleSelection}
    >
      <div
        style={{
          minWidth: 50,
          minHeight: 20,
          ...translateToFontConfig(others),
          ...style,
        }}
      >
        {newLineTransformation}
      </div>
    </StyledHolder>
  );
}

function ImageHolder({
  id,
  isPure,
  style,
  newUI,
  config = "",
  handleModuleSelection = null,
  selected = false,
  type = "FILE",
  useImgTag = true,
}) {
  const hasImageSize = newUI && newUI.image_size;

  return isPure ? (
    <div
      id={id}
      style={{
        width: 64,
        height: 64,
        padding: 0,
        minWidth: type === "FILE" ? 0 : 64,
        minHeight: type === "FILE" ? 0 : 64,
        ...style,
      }}
    >
      <img
        alt={"some_image"}
        src={
          type === "FILE"
            ? "data:image/png;base64," +
              (config === "" ? DEFAULT_IMAGE_DATA : config)
            : config === ""
            ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
            : config
        }
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  ) : (
    <StyledHolder
      id={id}
      style={{
        width: 64,
        height: 64,
        padding: 0,
        minWidth: type === "FILE" ? 0 : 64,
        minHeight: type === "FILE" ? 0 : 64,
        backgroundSize: !useImgTag
          ? hasImageSize &&
            (newUI.image_size === "Stretch"
              ? "100% 100%"
              : newUI.image_size.toLowerCase())
          : "",
        backgroundPosition: !useImgTag ? "center" : "",
        backgroundRepeat: !useImgTag ? "no-repeat" : "",
        backgroundImage: !useImgTag
          ? 'url("' +
            (config === ""
              ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
              : config) +
            '")'
          : "",
        ...style,
      }}
      selected={selected}
      onClick={handleModuleSelection}
    >
      {useImgTag && (
        <img
          alt=""
          src={
            type === "FILE"
              ? "data:image/png;base64," +
                (config === "" ? DEFAULT_IMAGE_DATA : config)
              : config === ""
              ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
              : config
          }
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      )}
    </StyledHolder>
  );
}

export function ButtonConfig({
  config: { text_config, color, gradient_config, borders },
  index,
  moduleType,
  onModuleSelection,
  style,
}) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onModuleSelection(e, MODULE_TYPES.BUTTON + (index + 1));
      }}
      style={{
        padding: "2px 12px",
        background:
          color === "#"
            ? "transparent"
            : gradient_config
            ? `linear-gradient(${gradient_config.colors.join(",")})`
            : color,
        color: text_config?.color || "#ffffff",
        fontFamily: text_config?.font_family || "sans-serif",
        borderRadius: (borders && borders.radius) || 4,
        fontSize: Number(text_config?.size) || 12,
        ...style,
        ...getFontStyle(text_config?.style.toLowerCase()),
      }}
    >
      <StyledHolder
        // bgColor={bgColor}
        selected={moduleType === MODULE_TYPES.BUTTON_TEXT + (index + 1)}
        isPure={true}
        onClick={(e) => {
          e.stopPropagation();
          onModuleSelection(e, MODULE_TYPES.BUTTON_TEXT + (index + 1));
        }}
      >
        {text_config.text}
      </StyledHolder>
    </div>
  );
}

function ButtonsHolder({
  id,
  bgColor,
  config,
  style,
  buttonHolderStyle,
  buttonStyledHolderStyle = {},
  buttonMarginRight = 8,
  buttonPosition = BUTTONS_POSITION.RIGHT,
  moduleType,
  onModuleSelection,
  isPure = false,
}) {
  return (
    <div
      id={id}
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: getButtonPosition(buttonPosition),
        ...buttonHolderStyle,
      }}
    >
      {config &&
        Array.isArray(config) &&
        config.map((oneButton, index) => (
          <StyledHolder
            key={`buttons_${index}`}
            bgColor={bgColor}
            selected={moduleType === MODULE_TYPES.BUTTON + (index + 1)}
            isPure={isPure}
            style={{ ...buttonStyledHolderStyle }}
          >
            <ButtonConfig
              style={{
                marginRight:
                  config.length > 1 && index === 0 ? buttonMarginRight : "",
                ...style,
              }}
              config={oneButton}
              key={`buttons_${index}`}
              onModuleSelection={onModuleSelection}
              moduleType={moduleType}
              index={index}
            />
          </StyledHolder>
        ))}
    </div>
  );
}

function VideoButtonHolder({ config, onModuleSelection, children }) {
  return (
    <IconButton
      style={{
        color: config?.color,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onModuleSelection(e, MODULE_TYPES.VIDEO_BUTTON);
      }}
    >
      {children}
    </IconButton>
  );
}

export const getBorderWidth = (border) => {
  return border !== undefined ? border.width : 0;
};

export const getArrowPosition = (position) => {
  switch (position) {
    case POSITION_ENUM.BOTTOM:
      return "bottom: 100%; left: 50%";
    case POSITION_ENUM.TOP:
      return "top: 100%; left: 50%";
    case POSITION_ENUM.LEFT:
      return "bottom: 50%; left: calc(100% + 12px);";
    case POSITION_ENUM.RIGHT:
      return "bottom: 50%; right: 100%";
    default:
      return "";
  }
};

export const getTooltipArrow = (props) => {
  if (!props.border) {
    return `
        content: '';
        position: absolute;
        ${getArrowPosition(props.position)}
        margin-left: -12px;
        border-width: 12px;
        border-style: solid;
        border-left-color: transparent;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-${props.position.toLowerCase()}-color: ${props.bgColor};
    `;
  } else {
    return `
        content: '';
        position: absolute;
        background: ${props.border.color};
        bottom: 100%;
        left: 50%;
        margin-left: -2px;
        height: 30px;
        width: 4px;
    `;
  }
};

export const getTooltipArrowBulb = (props) => {
  return `
        content: '';
        position: absolute;
        margin-left: -6px;
        bottom: calc(100% + 24px);
        background: ${props.border.color};
        left: 50%;
        height: 12px
        width: 12px;
        border-radius: 8px;
        border: none;
    `;
};

export const StyledDiv = styled.div`
  max-width: 360px;
  min-width: 180px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#ff0000")};
  padding: 8px;
  position: relative;
  line-height: 24px;
  z-index: 5;
  border-radius: ${(props) => (props.cornerRadius ? props.cornerRadius : 0)}px;
  border: ${(props) =>
    props.border !== undefined
      ? getBorderWidth(props.border) + "px solid" + props.border.color
      : "inherit"};
  margin: 24px;
  &::after {
    ${(props) => (props.border ? getTooltipArrowBulb(props) : "content: '';")}
  }
  &::before {
    ${(props) => getTooltipArrow(props)}
  }
`;

export const HoverDiv = styled.div`
  background: unset;
  &:hover {
    border: 1px solid #2979ff;
    box-shadow: ${(props) =>
      props.isFooter
        ? "0 -3px 3px rgba(18, 66, 74, 0.25)"
        : "0 3px 3px rgba(18, 66, 74, 0.25)"};
    cursor: pointer;
  }
`;

export const getLayoutBasedOnPosition = (position) => {
  switch (position) {
    case POSITION_ENUM.TOP:
      return {
        flexDirection: "column",
      };
    case POSITION_ENUM.LEFT:
      return {
        flexDirection: "row",
      };
    case POSITION_ENUM.BOTTOM:
      return {
        flexDirection: "column-reverse",
      };
    case POSITION_ENUM.RIGHT:
      return {
        flexDirection: "row-reverse",
      };
    default:
      return {
        flexDirection: "row",
      };
  }
};

export const ORIENTATION_ENUM = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
};

export { ImageHolder, TextHolder, ButtonsHolder, VideoButtonHolder };

export const onModuleSelection = (dispatch, moduleName, prevModule) => {
  dispatch({
    type: SET_MODULE_TYPE,
    value: moduleName === prevModule ? "" : moduleName,
  });
  sendEvent(moduleName, { isExpanded: !(moduleName === prevModule) });
};

const buttonActions = {
  SET_TEXT: SET_BUTTON_TEXT,
  SET_COLOR: SET_BUTTON_COLOR,
  SET_FONT_FAMILY: SET_BUTTON_FONT_FAMILY,
  SET_FONT_SIZE: SET_BUTTON_FONT_SIZE,
  SET_FONT_STYLE: SET_BUTTON_FONT_STYLE,
  SET_IMAGE: SET_IMAGE,
  SET_BG_COLOR: SET_BUTTON_BG_COLOR,
};

const actionButtonActions = {
  ...buttonActions,
  SET_IMAGE: SET_BUTTON_IMAGE,
};

const textActions = {
  SET_COLOR: SET_COLOR,
  SET_FONT_FAMILY: SET_FONT_FAMILY,
  SET_FONT_SIZE: SET_FONT_SIZE,
  SET_FONT_STYLE: SET_FONT_STYLE,
  SET_TEXT: SET_TEXT,
};

export const getDataForModuleType = (ui, moduleType) => {
  const {
    action_class,
    layout_type,
    action_buttons_config = [],
    corners = { width: 0 },
    buttons_config = [],
    title_config,
    text_config,
    image = "",
    bg_color,
    bg_image = "",
    border_radius,
    image_size = "",
    action_config = {},
    x_icon_color,
    mini_color,
    sound_icon_color,
  } = ui;

  let config = null;
  let keyName = "";
  let actions = null;
  let buttonConfig = null;
  switch (moduleType) {
    case MODULE_TYPES.BACKGROUND:
      buttonConfig = {
        color: bg_color,
      };
      if (action_class === ACTION_CLASSES.TOOLTIP) {
        buttonConfig.border_radius = corners.width;
      }
      if (action_class === ACTION_CLASSES.INAPP) {
        buttonConfig.border_radius = border_radius;
      }
      if (layout_type === INAPP_LAYOUT_TYPES.FULL_SCREEN_MODAL) {
        buttonConfig.color = "#";
      }
      actions = {
        SET_BG_COLOR: SET_BACKGROUND_COLOR,
        SET_BORDER_RADIUS:
          action_class === ACTION_CLASSES.INAPP
            ? SET_BORDER_BOTTOM_RADIUS
            : SET_BORDER_RADIUS,
      };
      break;
    case MODULE_TYPES.TITLE:
      config = title_config;
      keyName = "title_config";
      actions = textActions;
      break;
    case MODULE_TYPES.DESCRIPTION:
      config = text_config;
      keyName = "text_config";
      actions = textActions;
      break;
    case MODULE_TYPES.BUTTON1:
    case MODULE_TYPES.BUTTON2:
    case MODULE_TYPES.BUTTON_TEXT1:
    case MODULE_TYPES.BUTTON_TEXT2:
      if (
        moduleType === MODULE_TYPES.BUTTON_TEXT1 ||
        moduleType === MODULE_TYPES.BUTTON1
      ) {
        buttonConfig = buttons_config[0];
      } else {
        buttonConfig = buttons_config[1];
      }
      config = buttonConfig?.text_config;
      keyName = [buttonConfig?.__id, "text_config"];
      actions = buttonActions;
      break;
    case MODULE_TYPES.ACTION_BUTTON1:
    case MODULE_TYPES.ACTION_BUTTON2:
    case MODULE_TYPES.ACTION_BUTTON3:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON1) {
        buttonConfig = action_buttons_config[0];
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON2) {
        buttonConfig = action_buttons_config[1];
      } else {
        buttonConfig = action_buttons_config[2];
      }
      actions = buttonActions;
      break;
    case MODULE_TYPES.ACTION_BUTTON_1_TEXT:
    case MODULE_TYPES.ACTION_BUTTON_2_TEXT:
    case MODULE_TYPES.ACTION_BUTTON_3_TEXT:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_TEXT) {
        buttonConfig = action_buttons_config[0];
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_TEXT) {
        buttonConfig = action_buttons_config[1];
      } else {
        buttonConfig = action_buttons_config[2];
      }
      config = buttonConfig?.text_config;
      keyName = [buttonConfig?.__id, "text_config"];
      actions = actionButtonActions;
      break;
    case MODULE_TYPES.ACTION_BUTTON_1_DESC:
    case MODULE_TYPES.ACTION_BUTTON_2_DESC:
    case MODULE_TYPES.ACTION_BUTTON_3_DESC:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_DESC) {
        buttonConfig = action_buttons_config[0];
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_DESC) {
        buttonConfig = action_buttons_config[1];
      } else {
        buttonConfig = action_buttons_config[2];
      }
      config = buttonConfig?.description_config;
      keyName = [buttonConfig?.__id, "description_config"];
      actions = actionButtonActions;
      break;
    case MODULE_TYPES.ACTION_BUTTON_1_IMAGE:
    case MODULE_TYPES.ACTION_BUTTON_2_IMAGE:
    case MODULE_TYPES.ACTION_BUTTON_3_IMAGE:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_IMAGE) {
        buttonConfig = action_buttons_config[0];
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_IMAGE) {
        buttonConfig = action_buttons_config[1];
      } else {
        buttonConfig = action_buttons_config[2];
      }
      config = buttonConfig?.image;
      keyName = buttonConfig?.__id;
      actions = actionButtonActions;
      break;
    case MODULE_TYPES.BG_IMAGE_URL:
    case MODULE_TYPES.IMAGE_URL:
      config = {
        image: image,
        image_size: image_size,
        bg_image: bg_image,
        action_config: action_config,
      };
      actions = {
        SET_IMAGE: SET_IMAGE,
        SET_BG_IMAGE: SET_BG_IMAGE,
        SET_BG_IMAGE_SIZE: SET_BG_IMAGE_SIZE,
      };
      break;
    case MODULE_TYPES.IMAGE:
      actions = {
        SET_IMAGE: SET_IMAGE,
      };
      break;
    case MODULE_TYPES.VIDEO_BUTTON:
      config = {
        x_icon_color,
        mini_color,
        sound_icon_color,
      };
      actions = {
        SET_VIDEO_BUTTON_COLOR,
      };
      break;
    default:
      break;
  }

  return { config, keyName, actions, buttonConfig };
};
